import { useEffect } from "react";
import { Link } from "react-router-dom"
import AOS from "aos";
import "aos/dist/aos.css";

function Home() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false
        });
    }, []);
    return (
        <>
            <section className="@ @">
                <div className="banner-content v3">
                    <div className="banner-img" style={{ backgroundImage: "url('/assets/images/2.png')" }}>
                        <div className="section-title center">
                            <div className="section-title-inner w-v3 center">
                                <h4 className="sub-titlev3 animate__animated animate__fadeInUp" style={{ animationDuration: '1s' }}>Tanqidiy fikrla</h4>
                                <h2 className="big-title s-color-white animate__animated animate__fadeInUp" style={{ animationDuration: '1s' }}>Mediasavodxonlik — axborot xavfsizligining asosi</h2>
                            </div>
                        </div>
                        <div className="all-btn animate__animated animate__fadeInUp" style={{ animationDuration: '1s' }}>
                            <Link to='/videos' className="btn-p v1 btn-blue2 rounded icon-v1">Boshlash</Link>
                        </div>
                        <div className="slider-boder"></div>
                        <div className="slider-boder2"></div>
                        <div className="slider-boder3"></div>
                        <div className="slider-boder4"></div>
                    </div>
                </div>
            </section>
            <section className="features">
                <div className="container-xl">
                    <div className="row">
                        <div className="col-xl-4 col-md-6">
                            <div className="features-card">
                                <div className="card-img">
                                    <img src="/assets/images/card-img-3.jpg" alt="card-img" />
                                </div>
                                <div className="card-content">
                                    <div className="content-icon">
                                        <i className="my-icon icon-education-empowering-learne"></i>
                                    </div>
                                    <h4 className="title">Videodarslar</h4>
                                    <p className="para">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur corrupti dolores omnis tenetur voluptatibus sint.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <div className="features-card">
                                <div className="card-img">
                                    <img src="/assets/images/card-img-1.jpg" alt="card-img" />
                                </div>
                                <div className="card-content">
                                    <div className="content-icon">
                                        <i className="my-icon icon-educational-leadership"></i>
                                    </div>
                                    <h4 className="title">Ma'ruza mashg'ulotlari</h4>
                                    <p className="para">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur corrupti dolores omnis tenetur voluptatibus sint.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <div className="features-card">
                                <div className="card-img">
                                    <img src="/assets/images/card-img-2.jpg" alt="card-img" />
                                </div>
                                <div className="card-content">
                                    <div className="content-icon">
                                        <i className="my-icon icon-embark-empowerment"></i>
                                    </div>
                                    <h4 className="title">Seminar mashg'ulotlari</h4>
                                    <p className="para">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur corrupti dolores omnis tenetur voluptatibus sint.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="education-video-watch">
                <div className="container">
                    <div className="education-video-section" data-aos="fade-up" data-aos-duration="1000">
                        <div className="video-img">
                            <img src="/assets/images/video-img1.jpg" alt="video-img" />
                        </div>
                        <a href="https://www.youtube.com/watch?v=6cR4_9srSC0" className="popup-vimeo youtube play-video-button">
                            <div className="video-icon">
                                <i className="my-icon icon-play"></i>
                            </div>
                        </a>
                    </div>
                    <div className="section-title center">
                        <div className="section-title-inner w-v4 center">
                            <h2 className="big-title s-color-black" data-aos="fade-up" data-aos-duration="1000">
                                Medisavodxonlik nima?
                            </h2>
                            <p className="title-para sp-color-black" data-aos="fade-up" data-aos-duration="1000">
                                Medisavodxonlik haqida ma'lumot olish uchun ushbu videoni tomosha qiling. Chuqur o'rganish uchun platformamizdagi videodarslarni ko'rib chiqing.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="coursesv3 @ @">
                <div className="container">
                    <div className="courses-cards v3">
                        <div className="swiper mySwiper-courses swiper-initialized swiper-horizontal swiper-backface-hidden">
                            <div className="swiper-wrapper" id="swiper-wrapper-4232106cd813f9ae7" aria-live="off" style={{ transitionDuration: '0ms', transform: "translate3d(-1326px, 0px, 0px)", transitionDelay: '0ms' }}>
                                <div className="swiper-slide" style={{ width: '633px', marginRight: '30px' }} role="group" aria-label="2 / 4" data-swiper-slide-index="1">
                                    <div className="courses-card">
                                        <div className="user-img">
                                            <img src="/assets/images/user-img-2.jpg" alt="user-img" />
                                        </div>
                                        <div className="courses-card-content">
                                            <h4 className="title">Axborot hujumlari va kiberjinoyat</h4>
                                            <Link to='/videos' className="btn-p icon-v1">Batafsil<i className="my-icon icon-arrow-right"></i></Link>
                                        </div>

                                    </div>
                                </div>
                                <div className="swiper-slide" style={{ width: '633px', marginRight: '30px' }} role="group" aria-label="2 / 4" data-swiper-slide-index="1">
                                    <div className="courses-card">
                                        <div className="user-img">
                                            <img src="/assets/images/user-img-2.jpg" alt="user-img" />
                                        </div>
                                        <div className="courses-card-content">
                                            <h4 className="title">Axborot hujumlari va kiberjinoyat</h4>
                                            <Link to='/videos' className="btn-p icon-v1">Batafsil<i className="my-icon icon-arrow-right"></i></Link>
                                        </div>

                                    </div>
                                </div>
                                <div className="swiper-slide" style={{ width: '633px', marginRight: '30px' }} role="group" aria-label="2 / 4" data-swiper-slide-index="1">
                                    <div className="courses-card">
                                        <div className="user-img">
                                            <img src="/assets/images/user-img-2.jpg" alt="user-img" />
                                        </div>
                                        <div className="courses-card-content">
                                            <h4 className="title">Axborot hujumlari va kiberjinoyat</h4>
                                            <Link to='/videos' className="btn-p icon-v1">Batafsil<i className="my-icon icon-arrow-right"></i></Link>
                                        </div>

                                    </div>
                                </div>
                                <div className="swiper-slide" style={{ width: '633px', marginRight: '30px' }} role="group" aria-label="2 / 4" data-swiper-slide-index="1">
                                    <div className="courses-card">
                                        <div className="user-img">
                                            <img src="/assets/images/user-img-2.jpg" alt="user-img" />
                                        </div>
                                        <div className="courses-card-content">
                                            <h4 className="title">Axborot hujumlari va kiberjinoyat</h4>
                                            <Link to='/videos' className="btn-p icon-v1">Batafsil<i className="my-icon icon-arrow-right"></i></Link>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                        </div>
                        <div className="swiper-button-next" tabIndex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-4232106cd813f9ae7">Keyingi</div>
                        <div className="swiper-button-prev" tabIndex="0" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-4232106cd813f9ae7">Oldingi</div>
                        <div className="swiper-pagination"></div>
                    </div>
                </div>
            </section>
            <section className="skill-section mb-120 py-100">
                <div className="container">
                    <ul className="skill-items">
                        <li className="skill-item">
                            <div className="item-icon">
                                <i className="my-icon icon-courses-completed"></i>
                            </div>
                            <div className="item-content">
                                <h5 className="title"><span className="counter">4.8</span>K</h5>
                                <p className="para">Foydalanuvchilar</p>
                            </div>
                        </li>
                        <li className="skill-item">
                            <div className="item-icon">
                                <i className="my-icon icon-media-activities"></i>
                            </div>
                            <div className="item-content">
                                <h5 className="title"><span className="counter">25</span></h5>
                                <p className="para">Videodarslar</p>
                            </div>
                        </li>
                        <li className="skill-item">
                            <div className="item-icon">
                                <i className="my-icon icon-skill-expert"></i>
                            </div>
                            <div className="item-content">
                                <h5 className="title"><span className="counter">101</span></h5>
                                <p className="para">Topshiriqlar</p>
                            </div>
                        </li>
                        <li className="skill-item">
                            <div className="item-icon">
                                <i className="my-icon icon-happy-students"></i>
                            </div>
                            <div className="item-content">
                                <h5 className="title"><span className="counter">306</span></h5>
                                <p className="para">Testlar</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="skill-left-img">
                    <img src="/assets/images/skill-left-img.png" alt="skill-left-img" />
                </div>
                <div className="skill-right-img">
                    <img src="/assets/images/skill-right-img.png" alt="skill-right-img" />
                </div>
            </section>
            <section className="my-120 @">
                <div className="container-xl">
                    <div className="section-title center">
                        <div className="section-title-inner center w-v4">
                            <h4 className="sub-title" data-aos="fade-down" data-aos-duration="1000">So'nggi darslar</h4>
                            <h2 className="big-title s-color-black" data-aos="fade-up" data-aos-duration="1000">
                                Platformaga yuklangan oxirgi mashg'ulotlar
                            </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                            <div className="news-card">
                                <div className="news-card-img">
                                    <a href="#">
                                        <img src="/assets/images/card-img-1_1.jpg" alt="card-img" />
                                    </a>
                                </div>
                                <div className="news-card-content">
                                    <div className="content-top">
                                        <div className="date"><div className="content-icon"><i className="fas fa-bookmark"></i></div>Seminar</div>
                                    </div>
                                    <h4 className="title"><a href="#">Media maydon tuzilishi va ta'siri</a></h4>
                                    <p className="para">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo nam quia nisi magnam. Iusto, expedita!...</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                            <div className="news-card">
                                <div className="news-card-img">
                                    <img src="/assets/images/courses-img-9.jpg" alt="card-img" />
                                </div>
                                <div className="news-card-content">
                                    <div className="content-top">
                                        <div className="date"><div className="content-icon"><i className="fas fa-bookmark"></i></div>Ma'ruza</div>
                                    </div>
                                    <h4 className="title"><a href="#">Virtual o'yinlarning yoshlar ongiga ta'siri</a></h4>
                                    <p className="para">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsum id recusandae, temporibus nostrum nulla....</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                            <div className="news-card">
                                <div className="news-card-img">
                                    <a href="#">
                                        <img src="/assets/images/card-img-3_1.jpg" alt="card-img" />
                                    </a>
                                </div>
                                <div className="news-card-content">
                                    <div className="content-top">
                                        <div className="date"><div className="content-icon"><i className="fas fa-bookmark"></i></div>Seminar</div>
                                    </div>
                                    <h4 className="title"><a href="#">Ijtimoiy tarmoqlarda axborot xurujlari</a></h4>
                                    <p className="para">Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae dolorem labore quam quod enim et?...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Home